__webpack_require__.p = "/assets/template/";